import { useState, useEffect, useCallback } from 'react'

const NAMES = [
  'Lina María F.',
  'Ana Laura G.',
  'Camila R.',
  'Valentina P.',
  'Sofía M.',
  'Isabella T.',
  'Mariana L.',
  'Daniela C.',
  'Carlos A.',
  'Andrés M.',
  'Juan Pablo R.',
  'Santiago V.',
]

const CITIES = [
  'Bogotá',
  'Medellín',
  'Cali',
  'Barranquilla',
  'Bucaramanga',
  'Pereira',
  'Cartagena',
  'Manizales',
]

export interface NotificationData {
  id: string
  name: string
  city: string
  timeAgo: string
}

export function usePurchaseNotifications(enabled: boolean = true) {
  const [currentNotification, setCurrentNotification] =
    useState<NotificationData | null>(null)
  const [isVisible, setIsVisible] = useState(false)

  const dismiss = useCallback(() => {
    setIsVisible(false)
  }, [])

  useEffect(() => {
    if (!enabled) return

    let showTimeout: NodeJS.Timeout
    let hideTimeout: NodeJS.Timeout

    const scheduleNextNotification = () => {
      // Random interval between 25s and 45s
      const nextInterval =
        Math.floor(Math.random() * (45000 - 25000 + 1)) + 25000

      showTimeout = setTimeout(() => {
        const randomName = NAMES[Math.floor(Math.random() * NAMES.length)]
        const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)]
        const randomMinutes = Math.floor(Math.random() * 59) + 1

        setCurrentNotification({
          id: Date.now().toString(),
          name: randomName,
          city: randomCity,
          timeAgo: `hace ${randomMinutes} min`,
        })

        setIsVisible(true)

        // Auto hide after 5 seconds
        hideTimeout = setTimeout(() => {
          setIsVisible(false)
          scheduleNextNotification()
        }, 5000)
      }, nextInterval)
    }

    // Initial delay before first notification (10s)
    showTimeout = setTimeout(() => {
      scheduleNextNotification()
    }, 10000)

    return () => {
      clearTimeout(showTimeout)
      clearTimeout(hideTimeout)
    }
  }, [enabled])

  return { currentNotification, isVisible, dismiss }
}
